export default "__VITE_ASSET__da25fb16__"